import type { TypedDocumentNode } from '@apollo/client';
import gql from 'graphql-tag';

export type RouteServer = {
  asn: number;
  ips: string[];
  name: string;
  resourceGroup: string;
  vpcCloudId: string;
  vpcResourceGroup: string;
  addressPrefix?: string;
  publicIp?: string;
  bgpConnectionsCount?: number;
  maxMachines?: number;
  kind?: RouteServerKind;
};

export enum RouteServerKind {
  VWAN = 'VWAN',
  ROUTE_SERVER = 'ROUTE_SERVER',
}

export type RouteServersResponse = {
  azureRouteServers: RouteServer[];
};

export type RouteServersInput = {
  cloudServiceId?: string;
  subscriptionId?: string;
  datacenterId?: string;
  resourceGroup?: string;
  vnetResourceGroup?: string;
};

export const RouteServersQuery: TypedDocumentNode<RouteServersResponse, RouteServersInput> = gql`
  query AzureRouteServers(
    $cloudServiceId: String!
    $datacenterId: String
    $vnetResourceGroup: String
    $resourceGroup: String
    $subscriptionId: String
  ) {
    azureRouteServers(
      cloudServiceId: $cloudServiceId
      datacenterId: $datacenterId
      vnetResourceGroup: $vnetResourceGroup
      resourceGroup: $resourceGroup
      subscriptionId: $subscriptionId
    ) {
      asn
      name
      ips
      resourceGroup
      addressPrefix
      vnetCloudId
      vnetResourceGroup
      addressPrefix
      publicIp
      bgpConnectionsCount
      maxMachines @client
      kind
    }
  }
`;
